import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const RomanianPhoneInput = ({ value, onChange, inputError }) => {
  return (
    <PhoneInput
      country={"ro"}
      value={value}
      onChange={onChange}
      countryCodeEditable={false}
      disableDropdown={true}
      inputProps={{
        name: "contact",
        required: true,
      }}
      inputStyle={{
        width: "100%",
        borderColor: inputError ? "#d32f2f" : "#ccc",
        padding: "20px 50px",
      }}
      buttonStyle={{ borderColor: inputError ? "#d32f2f" : "#ccc" }}
    />
  );
};

export default RomanianPhoneInput;
